// Inject a "Twemoji Country Flags" webfont on browsers that render normal
// emoji but not country flags (Chromium on Windows). Inlined from
// country-flag-emoji-polyfill (TalkJS, MIT) to avoid CRA 4 / Webpack 4
// interop issues with the package's ESM-first build shape.
// The font is loaded ONLY when needed — macOS/iOS/Android/modern Firefox
// already render flags natively and pay no cost.
export function polyfillCountryFlagEmojis() {
    if (typeof window === "undefined" || typeof document === "undefined") {
        return false;
    }

    const probeFontStack =
        '"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol","Noto Color Emoji",sans-serif';
    const canvas = document.createElement("canvas");
    canvas.width = canvas.height = 1;
    const ctx = canvas.getContext("2d", { willReadFrequently: true });
    if (!ctx) return false;
    ctx.textBaseline = "top";
    ctx.font = `100px ${probeFontStack}`;
    ctx.scale(0.01, 0.01);

    const paint = (text, color) => {
        ctx.clearRect(0, 0, 100, 100);
        ctx.fillStyle = color;
        ctx.fillText(text, 0, 0);
        return ctx.getImageData(0, 0, 1, 1).data.join(",");
    };
    const supports = (text) => {
        const onWhite = paint(text, "#fff");
        const onBlack = paint(text, "#000");
        return onWhite === onBlack && !onBlack.startsWith("0,0,0,");
    };

    if (supports("\u{1F60A}") && !supports("\u{1F1E8}\u{1F1ED}")) {
        const style = document.createElement("style");
        style.textContent =
            "@font-face {" +
            "  font-family: \"Twemoji Country Flags\";" +
            "  unicode-range: U+1F1E6-1F1FF, U+1F3F4, U+E0062-E0063, U+E0065, U+E0067, U+E006C, U+E006E, U+E0073-E0074, U+E0077, U+E007F;" +
            "  src: url('https://cdn.jsdelivr.net/npm/country-flag-emoji-polyfill@0.1/dist/TwemojiCountryFlags.woff2') format('woff2');" +
            "  font-display: swap;" +
            "}";
        document.head.appendChild(style);
        return true;
    }
    return false;
}
